export const AuthorizationConstants = {
    CAN_EDIT_POLICY: "CanEdit",
    FINDEST_ADMINISTRATOR_ROLE: "FindestAdministrator",
    FINDEST_SCOUT_ROLE: "FindestScout",
} as const;